import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import Link from '@ux/link';
import noop from 'lodash.noop';
import { Menu, MenuButton } from '@ux/menu';
import NavBarItemChildren from './NavBarItemChildren';
import ChevronDown from '@ux/icon/chevron-down';

const NavIcon = ({ className }) => (
  <span className={ classNames(className, 'icon', 'uxicon') } />
);

NavIcon.propTypes = {
  className: PropTypes.string.isRequired
};

const NavBarItem = forwardRef((props, forwardedRef) => {
  const {
    icon = '',
    active = false,
    className = '',
    id = '',
    href = '#',
    target = null,
    dataAttrs = {},
    caption = null,
    title = null,
    eid = '',
    children = null,
    onClick = noop
  } = props;

  const _className = classNames(
    'in-page-nav-item',
    { active },
    className
  );

  let iconJsx;

  if (icon) {
    iconJsx = <NavIcon className={ icon } />;
  }

  if (children && children.length) {
    return (
      <Menu ref={ forwardedRef } as='li' id='horizontal-nav' className={ _className }>
        <MenuButton icon={ <ChevronDown /> }>
          { caption || title }
        </MenuButton>
        <NavBarItemChildren items={ children } />
      </Menu>
    );
  }
  return (
    <li ref={ forwardedRef } className={ _className }>
      <Link
        className='in-page-nav-link'
        id={ id }
        href={ href || '#' }
        target={ target }
        onClicked={ onClick }
        data-eid={ eid }
        { ...dataAttrs }
      >
        { caption || title }
        { iconJsx }
      </Link>
    </li>
  );

});

NavBarItem.propTypes = {
  icon: PropTypes.string,
  active: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  dataAttrs: PropTypes.shape({}),
  caption: PropTypes.node,
  title: PropTypes.node,
  eid: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.shape(NavBarItem.propTypes))
};

const NavBarItemPropTypes = NavBarItem.propTypes;
export { NavBarItem as default, NavBarItemPropTypes };
